import * as monacoEditor from 'monaco-editor';

import { getReferencesForPosition } from './getReferencesForPosition';
import { ProviderState } from './providerHelpers';

export function sdlDefinitionProviderFactory(
  providerStateRef: React.RefObject<ProviderState>,
): monacoEditor.languages.DefinitionProvider {
  return {
    async provideDefinition(
      model,
      position,
    ): Promise<null | monacoEditor.languages.Definition> {
      return getReferencesForPosition(model, position, providerStateRef);
    },
  };
}
